/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { CashBoxesStatisticsDto } from './statisticsClient.typings';
import { factoryT } from 'factory-t';

export const cashBoxesStatisticsFactory = factoryT<CashBoxesStatisticsDto>({
    total: 100,
    states: {
        active: 951,
        blocked: 500,
        inactive: 220000,
        notBlocked: 30000000,
        offline: undefined, //700,
        online: undefined, //1100,
    },
});
